export enum UserRole {
  Owner = "Owner",
  Admin = "Admin",
  Collaborator = "Collaborator",
}
